import { useState, useEffect } from 'react'
import { HashRouter as BrowserRouter, Routes, Route } from 'react-router-dom'
import Home from './pages/Home'
import AICoach from './pages/AICoach'
import Venues from './pages/Venues'
import Ladder from './pages/Ladder'
import Gym from './pages/Gym'
import Treadmill from './pages/Treadmill'
import Download from './components/Download'
import Footer from './components/Footer'
import Navbar from './components/Navbar'

function App() {
  const [scrolled, setScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50)
    }
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <BrowserRouter>
      <div className="min-h-screen">
        <Navbar scrolled={scrolled} />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/aicoach" element={<AICoach />} />
          <Route path="/venues" element={<Venues />} />
          <Route path="/ladder" element={<Ladder />} />
          <Route path="/gym" element={<Gym />} />
          <Route path="/treadmill" element={<Treadmill />} />
        </Routes>
        <section id="download">
          <Download />
        </section>
        <Footer />
      </div>
    </BrowserRouter>
  )
}

export default App
